import React, { useEffect, useState } from 'react';
import { cleanupHighScores } from '../utils/cleanupScores';

interface CleanupResults {
  gamesFixed: number;
  scoresAdjusted: number;
  newStats: {
    gamesPlayed: number;
    averageScore: number;
    highScore: number;
    totalCorrectGuesses: number;
    averageYearsOff: number;
    lifetimePoints: number;
  };
}

export const ScoreCleanup: React.FC = () => {
  const [results, setResults] = useState<CleanupResults | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    try {
      const cleanupResults = cleanupHighScores();
      setResults(cleanupResults);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    }
  }, []);

  if (error) {
    return (
      <div className="p-4">
        <h1 className="text-xl font-bold mb-4">Score Cleanup Error</h1>
        <pre className="text-red-500">{error}</pre>
      </div>
    );
  }

  if (!results) {
    return (
      <div className="p-4">
        <h1 className="text-xl font-bold">Running cleanup...</h1>
      </div>
    );
  }

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold mb-4">Score Cleanup Complete</h1>
      <div className="space-y-2">
        <p>Games processed: {results.gamesFixed}</p>
        <p>Scores adjusted: {results.scoresAdjusted}</p>

        <h2 className="text-lg font-bold mt-4 mb-2">New Stats:</h2>
        <ul className="space-y-1">
          <li>Games played: {results.newStats.gamesPlayed}</li>
          <li>Average score: {results.newStats.averageScore}</li>
          <li>High score: {results.newStats.highScore}</li>
          <li>Total correct guesses: {results.newStats.totalCorrectGuesses}</li>
          <li>
            Average years off: {results.newStats.averageYearsOff.toFixed(2)}
          </li>
          <li>Lifetime points: {results.newStats.lifetimePoints}</li>
        </ul>
      </div>
    </div>
  );
};
